export default {
  'checkImage.checkFor': 'Check for',
  'checkImage.title': 'Check Info',
  'checkImage.notAvailable': 'Image is unavailable. Please try again later.'
};
